import styled, { css } from 'styled-components'

import { mediaMaxMobile, premiumFontCss } from '@blade/ui-theme'
import { BuyPremiumIcon } from '@root/entities/premium/ui'
import { useTranslation } from '@root/shared/localization'

const RATIO_BOOSER_ICON = 0.3
const RATIO_BOOSER_ICON_2 = 0.22
const SIZE = 140

export const PremiumUnauthorizedHeading: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Root>
      <Title>{t('common.d-premium')}</Title>
      <BuyPremiumIconAlt product="subscription" size={SIZE} />
      <BoosterIcon1 product="boosters" size={SIZE * RATIO_BOOSER_ICON} />
      <BoosterIcon2 product="boosters" size={SIZE * RATIO_BOOSER_ICON_2} />
      <BoosterIcon3 product="boosters" size={SIZE * RATIO_BOOSER_ICON_2} />
      <BoosterIcon4 product="boosters" size={SIZE * RATIO_BOOSER_ICON} />
    </Root>
  )
}

const Root = styled.div``

const Title = styled.h1`
  position: absolute;
  text-align: center;

  width: 100%;
  top: -160px;

  font-size: 100px;
  font-weight: 700;

  opacity: 0.3;
  ${premiumFontCss}

  --title-fade-mask: linear-gradient(
    180deg,
    #000 0%,
    rgb(0 0 0 / 40%) 50%,
    transparent 85%
  );

  mask-image: var(--title-fade-mask);
  -webkit-mask-image: var(--title-fade-mask);

  ${mediaMaxMobile(css`
    top: -120px;
    font-size: 60px;
  `)}
`

const BuyPremiumIconAlt = styled(BuyPremiumIcon)`
  position: absolute;
  top: -105px;
  left: calc(50% - 70px);
`

const BoosterIcon1 = styled(BuyPremiumIcon)`
  position: absolute;
  top: -20px;
  left: 127px;
  rotate: -30deg;
`

const BoosterIcon2 = styled(BuyPremiumIcon)`
  position: absolute;
  top: -70px;
  left: 192px;
  rotate: -30deg;
`

const BoosterIcon3 = styled(BuyPremiumIcon)`
  position: absolute;
  top: -100px;
  right: 210px;
  rotate: 10deg;
`

const BoosterIcon4 = styled(BuyPremiumIcon)`
  position: absolute;
  top: -25px;
  right: 150px;
  rotate: 15deg;
`
